export default {
  online_shop: 'Loja online',
  storefront: 'Loja',
  reservations: 'Reservas',
  import: 'Importação',
};
